import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { Cookie } from "lucide-react";
import { Button } from "@/components/ui/button";
import { Switch } from "@/components/ui/switch";
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogDescription } from "@/components/ui/dialog";
import { getConsent, saveConsent } from "@/lib/legal";

const CATS = [
  ["necessary", "Tecnici", "Necessari per accesso, sicurezza, prenotazione e preferenze. Sempre attivi."],
  ["analytics", "Statistiche", "Misurazione anonima delle visite. Attualmente non utilizzati."],
  ["marketing", "Marketing", "Pubblicità e profilazione. Attualmente non utilizzati."],
];

function Prefs({ open, onClose }) {
  const cur = getConsent();
  const [p, setP] = useState({ analytics: !!cur?.analytics, marketing: !!cur?.marketing });
  const save = (v) => { saveConsent(v); onClose(); };
  return (
    <Dialog open={open} onOpenChange={(o) => !o && onClose()}>
      <DialogContent data-testid="cookie-prefs-dialog">
        <DialogHeader>
          <DialogTitle>Preferenze cookie</DialogTitle>
          <DialogDescription>Scegli quali categorie consentire. Puoi cambiare idea in qualsiasi momento.</DialogDescription>
        </DialogHeader>
        <div className="space-y-4">
          {CATS.map(([k, label, desc]) => (
            <label key={k} className="flex items-start justify-between gap-4 rounded-xl border p-3">
              <span><b className="text-sm">{label}</b><span className="block text-xs text-slate-500">{desc}</span></span>
              <Switch checked={k === "necessary" || p[k]} disabled={k === "necessary"}
                onCheckedChange={(v) => setP((s) => ({ ...s, [k]: v }))} data-testid={`cookie-switch-${k}`} />
            </label>
          ))}
        </div>
        <div className="flex flex-wrap justify-end gap-2">
          <Button variant="outline" className="rounded-full" onClick={() => save({ analytics: false, marketing: false })} data-testid="cookie-prefs-reject">Rifiuta tutti</Button>
          <Button className="rounded-full" onClick={() => save(p)} data-testid="cookie-prefs-save">Salva preferenze</Button>
        </div>
      </DialogContent>
    </Dialog>
  );
}

export const CookieBanner = () => {
  const [show, setShow] = useState(() => !getConsent());
  const [prefs, setPrefs] = useState(false);
  useEffect(() => {
    const o = () => setPrefs(true);
    const c = () => setShow(!getConsent());
    window.addEventListener("open-cookie-prefs", o);
    window.addEventListener("cookie-consent-changed", c);
    return () => { window.removeEventListener("open-cookie-prefs", o); window.removeEventListener("cookie-consent-changed", c); };
  }, []);
  return (
    <>
      {show && !prefs && (
        <div className="fixed inset-x-3 bottom-3 z-50 mx-auto max-w-3xl rounded-2xl border bg-white/95 p-5 shadow-2xl backdrop-blur-md rise" data-testid="cookie-banner">
          <div className="flex items-start gap-3">
            <Cookie className="mt-0.5 h-5 w-5 shrink-0 text-[#61a229]" />
            <p className="text-sm text-slate-600">
              Usiamo solo cookie tecnici necessari al funzionamento del sito. Cookie di statistica o marketing verrebbero attivati solo con il tuo consenso.{" "}
              <Link to="/cookie" className="font-semibold text-[#61a229] hover:underline" data-testid="cookie-banner-policy-link">Cookie Policy</Link>
            </p>
          </div>
          <div className="mt-4 flex flex-wrap justify-end gap-2">
            <Button variant="ghost" className="rounded-full" onClick={() => setPrefs(true)} data-testid="cookie-customize-button">Personalizza</Button>
            <Button variant="outline" className="rounded-full" onClick={() => saveConsent({ analytics: false, marketing: false })} data-testid="cookie-reject-button">Rifiuta</Button>
            <Button className="rounded-full" onClick={() => saveConsent({ analytics: true, marketing: true })} data-testid="cookie-accept-button">Accetta tutti</Button>
          </div>
        </div>
      )}
      {prefs && <Prefs open onClose={() => setPrefs(false)} />}
    </>
  );
};
